var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPedidoPorAprobarConfirmado = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.2503 42.2222H110V31.1111C110 24.975 105.075 20 99.0003 20H74.2503V42.2222Z",
    fill: "#64B5F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9995 20H27.4995C21.4247 20 16.4995 24.975 16.4995 31.1111V108.889C16.4995 115.025 21.4247 120 27.4995 120H76.9995C83.0742 120 87.9995 115.025 87.9995 108.889V31.1111C87.9995 24.975 92.9247 20 98.9995 20Z",
    fill: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77 120H11C4.92525 120 0 115.025 0 108.889V100.556H66V108.889C66 115.025 70.9252 120 77 120ZM33 42.2223H71.5V47.7779H33V42.2223ZM33 56.1112H60.5V61.6668H33V56.1112ZM33 70.0001H71.5V75.5557H33V70.0001ZM33 83.889H60.5V89.4446H33V83.889Z",
    fill: "#64B5F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 30C120 46.5675 106.568 60 90 60C73.4325 60 60 46.5675 60 30C60 13.4325 73.4325 0 90 0C106.568 0 120 13.4325 120 30Z",
    fill: "#17CF63"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.75 15.25C82.0525 15.25 75 22.3025 75 31H69.75L76.5575 37.8075L76.68 38.0525L83.75 31H78.5C78.5 24.2275 83.9775 18.75 90.75 18.75C97.5225 18.75 103 24.2275 103 31C103 37.7725 97.5225 43.25 90.75 43.25C87.3725 43.25 84.31 41.8675 82.105 39.645L79.62 42.13C82.4725 44.9825 86.3925 46.75 90.75 46.75C99.4475 46.75 106.5 39.6975 106.5 31C106.5 22.3025 99.4475 15.25 90.75 15.25ZM89 24V32.75L96.49 37.195L97.75 35.0775L91.625 31.4375V24H89Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_28"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPedidoPorAprobarConfirmado, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/PedidoPorAprobarConfirmado.3874a2ce.svg";
export { ForwardRef as ReactComponent };